export default __webpack_public_path__ + "static/media/jaws.d25cf11c.svg";